export const useSupportWhatsappLink = () => {
  const { config } = useBusinessUnitResolver();

  const whatsappLink = computed(() => config.value?.supportWhatsappUrl ?? '');

  const whatsappLabel = computed(() => config.value?.supportWhatsappLabel ?? '');

  return {
    whatsappLink,
    whatsappLabel,
  };
};
